import * as Types from '../../../../__generated__/types.gqlgenerated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GhostwriterJobEligibilityQueryVariables = Types.Exact<{
  indeedJobKeys: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
}>;


export type GhostwriterJobEligibilityQuery = { __typename?: 'Query', ghostwriter: { __typename?: 'GhostwriterQueries', jobEligibility: Array<string> } };


export const GhostwriterJobEligibilityDocument = gql`
    query GhostwriterJobEligibility($indeedJobKeys: [String!]!) {
  ghostwriter {
    jobEligibility(indeedJobKeys: $indeedJobKeys)
  }
}
    `;

/**
 * __useGhostwriterJobEligibilityQuery__
 *
 * To run a query within a React component, call `useGhostwriterJobEligibilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGhostwriterJobEligibilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGhostwriterJobEligibilityQuery({
 *   variables: {
 *      indeedJobKeys: // value for 'indeedJobKeys'
 *   },
 * });
 */
export function useGhostwriterJobEligibilityQuery(baseOptions: Apollo.QueryHookOptions<GhostwriterJobEligibilityQuery, GhostwriterJobEligibilityQueryVariables> & ({ variables: GhostwriterJobEligibilityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GhostwriterJobEligibilityQuery, GhostwriterJobEligibilityQueryVariables>(GhostwriterJobEligibilityDocument, options);
      }
export function useGhostwriterJobEligibilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GhostwriterJobEligibilityQuery, GhostwriterJobEligibilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GhostwriterJobEligibilityQuery, GhostwriterJobEligibilityQueryVariables>(GhostwriterJobEligibilityDocument, options);
        }
export function useGhostwriterJobEligibilitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GhostwriterJobEligibilityQuery, GhostwriterJobEligibilityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GhostwriterJobEligibilityQuery, GhostwriterJobEligibilityQueryVariables>(GhostwriterJobEligibilityDocument, options);
        }
export type GhostwriterJobEligibilityQueryHookResult = ReturnType<typeof useGhostwriterJobEligibilityQuery>;
export type GhostwriterJobEligibilityLazyQueryHookResult = ReturnType<typeof useGhostwriterJobEligibilityLazyQuery>;
export type GhostwriterJobEligibilitySuspenseQueryHookResult = ReturnType<typeof useGhostwriterJobEligibilitySuspenseQuery>;
export type GhostwriterJobEligibilityQueryResult = Apollo.QueryResult<GhostwriterJobEligibilityQuery, GhostwriterJobEligibilityQueryVariables>;